import { useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { supportAgent } from "@/assets/images";

import "./FloatingSupportButton.scss";

const FloatingSupportButton = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname === "/login" || pathname.startsWith("/support")) {
    return null;
  }
  const handleSupportClick = () => {
    navigate("/support");
  };

  return (
    <div
      className={`Floating-support-container ${
        open ? "Floating-support--open" : ""
      }`}
      title="Support"
    >
      <div className="Floating-support-pill">
        {open && (
          <div
            className="Floating-support-icon"
            onClick={handleSupportClick}
            title="Support"
          >
            <img
              src={supportAgent}
              alt="Support"
            />
          </div>
        )}

        <div
          className="Floating-support-toggle"
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? "›" : "‹"}
        </div>
      </div>
    </div>
  );
};

export default FloatingSupportButton;
